<template>
  <div id="app">
    <div class="guoqing">
      <!-- TODO: 替换为COS地址 -->

      <img class="left" :src="`${IMG_URL}images/guoqing/1.png`" alt="" />
      <img class="right" :src="`${IMG_URL}images/guoqing/2.png`" alt="" />
    </div>
    <router-view />
  </div>
</template>

<script>
import { getToken } from "@/api/auth";

export default {
  name: "App",

  mounted() {
    this.browserRedirect();
    if (getToken()) {
      this.$store.dispatch("GetUserInfo");
    }
    this.$store.dispatch("getIndexConfig");
  },
  methods: {
    browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        localStorage.setItem("device", JSON.stringify({ type: "number", data: 1 })); // 作用于区分4个版本手机端是否有实名认证
        window.location.href = "/web/index/#/";
      }
    },
  },
};
</script>

<style lang="scss">
.guoqing {
  .left,
  .right {
    position: fixed;
    top: 10vh;
  }
  .left {
    left: 3vw;
    width: 8vw;
  }
  .right {
    top: 10vh;
    right: 3vw;
    width: 8vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue